<template>
    <div class="d-flex justify-content-center" :class="[flexDirection]">
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        reverse: Boolean,
        vertical: Boolean,
    },

    computed: {
        flexDirection() {
            let out = ''

            if (this.vertical) {
                out = 'flex-column'
            } else {
                out = 'flex-row'
            }

            if (this.reverse) {
                out += '-reverse'
            }

            return out
        },
    },
}
</script>
